// extracted by mini-css-extract-plugin
export var legendIndicator = "_8u-1";
export var legendRight = "_8u-0";